export default function Toast({ id, type, message, onClose }) {
    return (
        <div className={`toast-item toast-${type}`}>

            <img
                src={
                    type === "success"
                        ? "/icons/icons8-success-100.png"
                        : type === "error"
                            ? "/icons/icons8-cancel-100.png"
                            : "/icons/icons8-warning-100.png"
                }
                className="toast-icon"
                alt=""
            />


            <span className="toast-message">{message}</span>

            <button className="toast-close-btn" onClick={() => onClose(id)}>
                ✕
            </button>

        </div>
    );
}

